import React, {useEffect, useState} from "react";
import {Button, Col, DatePicker, Divider, Form, Input, Row, Select} from "antd";
import dayjs from "dayjs";
import {userService} from "../../services/user.service";
import {useSelector} from "react-redux";
import {ValidateIsAdult} from "../../utils/ProfileFunctions";

export const FormUserInformation = ({handleNextStatus,profileInfo,handleUpdateProfile}) => {
    const [user, setUser] = useState({
        firstName: null,
        lastName: null,
        birthday: null,
        pronoun: null,
    });
    const [form] = Form.useForm();
    const [currentDate] = useState(dayjs().subtract(18, "years"));
    const companyId = useSelector((state) => state.userSettings.companyId);

    const onSubmit = async () => {
        try {
            const response = await userService.editProfile(user,companyId);
            if (response.success) {
                handleUpdateProfile();
                handleNextStatus("default",2);
            }
        } catch (error) {
            console.error('Error en el registro:', error);
        }
    };

    const handleInputValue = (e) =>
        setUser({ ...user, [e.target.name]: e.target.value });

    const handleSelectPronoun = (value) => setUser({ ...user, pronoun: value });

    const handleBirthday = (_str, _date) => setUser({ ...user, birthday: _date });

    const handleDisabledDate = (current) => {
        return dayjs().subtract(18, "years") < current;
    };

    useEffect(() => {
        const isAdult = ValidateIsAdult(profileInfo?.birthday);
        form.setFieldsValue({
            firstName: profileInfo?.firstName,
            lastName: profileInfo?.lastName,
            email: profileInfo?.email,
            pronoun: (profileInfo?.pronoun) ? profileInfo?.pronoun : "",
            birthday: !(isAdult) ? dayjs(profileInfo?.birthday) : "",
        });
    }, [profileInfo]);

    return (
        <article className="profile__form">
            <Form
                form={form}
                className={"form-light"}
                onFinish={onSubmit}
                layout={"vertical"}
            >
                <Row gutter={[0,8]}>
                    <Col xs={24}>
                        <div className={"form-light__title"}>
                            <h4>Configura tu perfil</h4>
                            <Divider orientation={"center"}>Información personal</Divider>
                            <small className={"text-required"}>Los campos con <span>*</span> son obligatorios</small>
                        </div>
                    </Col>
                    <Col xs={24}>
                        <Form.Item
                            label={"Escribe tu nombre"}
                            name={"firstName"}
                            htmlFor={"firstName"}
                            rules={[
                                {
                                    required: true,
                                    message: "*Campo requerido",
                                },
                            ]}
                            onChange={handleInputValue}
                        >
                            <Input name={"firstName"} size={"large"} disabled={(profileInfo?.loginProvider === 3)} />
                        </Form.Item>
                    </Col>
                    <Col xs={24}>
                        <Form.Item
                            label={"Tu apellido"}
                            name={"lastName"}
                            htmlFor={"lastName"}
                            rules={[
                                {
                                    required: true,
                                    message: "*Campo requerido",
                                },
                            ]}
                            onChange={handleInputValue}
                        >
                            <Input name={"lastName"} size={"large"} disabled={(profileInfo?.loginProvider === 3)} />
                        </Form.Item>
                    </Col>
                    <Col xs={24}>
                        <Form.Item
                            label={"Tu cumpleaños"}
                            name={"birthday"}
                            htmlFor={"birthday"}
                            rules={[
                                {
                                    required: true,
                                    message: "*Campo requerido",
                                },
                            ]}
                        >
                            <DatePicker
                                name={"birthday"}
                                size={"large"}
                                placeholder={"Cumpleaños"}
                                picker={"date"}
                                onChange={handleBirthday}
                                showToday={false}
                                onFocus={() => {
                                    form.setFieldValue("birthday", currentDate);
                                    setUser({ ...user, birthday: currentDate });
                                }}
                                disabledDate={handleDisabledDate}
                                format={"DD/MMM/YYYY"}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24}>
                        <Form.Item
                            label={"Me identifico como..."}
                            name={"pronoun"}
                            htmlFor={"pronoun"}
                            rules={[
                                {
                                    required: true,
                                    message: "*Campo requerido",
                                },
                            ]}
                        >
                            <Select name={"pronoun"} onChange={handleSelectPronoun}>
                                <Select.Option value={"Él"}>Él</Select.Option>
                                <Select.Option value={"Ella"}>Ella</Select.Option>
                                <Select.Option value={"Elle"}>Elle</Select.Option>
                                <Select.Option value={"Otro"}>Otro</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    {/*
                    <Col xs={24}>
                        <Divider orientation={"center"}>Configuración extra</Divider>
                    </Col>

                    <Col xs={24}>
                        <Form.Item
                            className={"ant-form-item-switch"}
                            label={<div className={"ant-form-item-switch-label"}>
                                <p>Deseo recibir notificaciones</p>
                                <small>Mantente al tanto de todo lo que sucede en PrideMx</small>
                            </div>}
                            name={"notifications"}
                            htmlFor={"notifications"}
                        >
                            <Switch onChange={(value) => handleSwitch(value,"notifications")} size={"large"} />
                        </Form.Item>
                    </Col>
                    <Col xs={24}>
                        <Form.Item
                            className={"ant-form-item-switch"}
                            label={<div className={"ant-form-item-switch-label"}>
                                <p>Deseo recibir correos</p>
                                <small>Te mantendremos informado de nuestras dinámicas </small>
                            </div>}
                            name={"emails"}
                            htmlFor={"emails"}
                        >
                            <Switch size={"large"} onChange={(value) => handleSwitch(value,"emails")} />
                        </Form.Item>
                    </Col>
                    */}
                </Row>
                <div className={"form-light__footer"}>
                    <Button
                        htmlType={"button"}
                        type={"default"}
                        block={true}
                        onClick={() => handleNextStatus("default",1)}
                    >
                        Regresar
                    </Button>
                    <Button
                        htmlType={"submit"}
                        type={"primary"}
                        block={true}
                    >
                        Guardar
                    </Button>
                </div>
            </Form>
        </article>
    );
}